"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  kilo: {
    id: 'xsui.charts.numericSymbols.kilo',
    defaultMessage: 'k'
  },
  mega: {
    id: 'xsui.charts.numericSymbols.mega',
    defaultMessage: 'M'
  },
  giga: {
    id: 'xsui.charts.numericSymbols.giga',
    defaultMessage: 'G'
  },
  tera: {
    id: 'xsui.charts.numericSymbols.tera',
    defaultMessage: 'T'
  },
  peta: {
    id: 'xsui.charts.numericSymbols.peta',
    defaultMessage: 'P'
  },
  exa: {
    id: 'xsui.charts.numericSymbols.exa',
    defaultMessage: 'E'
  }
});

exports["default"] = _default;